export default __webpack_public_path__ + "static/media/ic_svc_galaxy_store.8bfb9b1f.png";